module.exports = __webpack_public_path__ + "img/stock3.a952fc35.png";